"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IS_PRODUCTION = void 0;
exports.IS_PRODUCTION = process.env.NODE_ENV === 'production';
